// @generated by protoc-gen-es v2.10.2 with parameter "target=js+dts,import_extension=none"
// @generated from file shopping/v1/shopping.proto (package shopping.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file shopping/v1/shopping.proto.
 */
export const file_shopping_v1_shopping = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message shopping.v1.ShoppingListItem.
 * Use `create(ShoppingListItemSchema)` to create a new message.
 */
export const ShoppingListItemSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 0);

/**
 * Describes the message shopping.v1.ShoppingList.
 * Use `create(ShoppingListSchema)` to create a new message.
 */
export const ShoppingListSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 1);

/**
 * Describes the message shopping.v1.ShoppingListSummary.
 * Use `create(ShoppingListSummarySchema)` to create a new message.
 */
export const ShoppingListSummarySchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 2);

/**
 * Describes the message shopping.v1.CreateShoppingListRequest.
 * Use `create(CreateShoppingListRequestSchema)` to create a new message.
 */
export const CreateShoppingListRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 3);

/**
 * Describes the message shopping.v1.ShoppingListItemInput.
 * Use `create(ShoppingListItemInputSchema)` to create a new message.
 */
export const ShoppingListItemInputSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 4);

/**
 * Describes the message shopping.v1.CreateShoppingListResponse.
 * Use `create(CreateShoppingListResponseSchema)` to create a new message.
 */
export const CreateShoppingListResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 5);

/**
 * Describes the message shopping.v1.GetShoppingListRequest.
 * Use `create(GetShoppingListRequestSchema)` to create a new message.
 */
export const GetShoppingListRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 6);

/**
 * Describes the message shopping.v1.GetShoppingListResponse.
 * Use `create(GetShoppingListResponseSchema)` to create a new message.
 */
export const GetShoppingListResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 7);

/**
 * Describes the message shopping.v1.ListShoppingListsRequest.
 * Use `create(ListShoppingListsRequestSchema)` to create a new message.
 */
export const ListShoppingListsRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 8);

/**
 * Describes the message shopping.v1.ListShoppingListsResponse.
 * Use `create(ListShoppingListsResponseSchema)` to create a new message.
 */
export const ListShoppingListsResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 9);

/**
 * Describes the message shopping.v1.UpdateShoppingListRequest.
 * Use `create(UpdateShoppingListRequestSchema)` to create a new message.
 */
export const UpdateShoppingListRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 10);

/**
 * Describes the message shopping.v1.UpdateShoppingListResponse.
 * Use `create(UpdateShoppingListResponseSchema)` to create a new message.
 */
export const UpdateShoppingListResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 11);

/**
 * Describes the message shopping.v1.DeleteShoppingListRequest.
 * Use `create(DeleteShoppingListRequestSchema)` to create a new message.
 */
export const DeleteShoppingListRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 12);

/**
 * Describes the message shopping.v1.DeleteShoppingListResponse.
 * Use `create(DeleteShoppingListResponseSchema)` to create a new message.
 */
export const DeleteShoppingListResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 13);

/**
 * Describes the message shopping.v1.AddShoppingListItemRequest.
 * Use `create(AddShoppingListItemRequestSchema)` to create a new message.
 */
export const AddShoppingListItemRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 14);

/**
 * Describes the message shopping.v1.AddShoppingListItemResponse.
 * Use `create(AddShoppingListItemResponseSchema)` to create a new message.
 */
export const AddShoppingListItemResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 15);

/**
 * Describes the message shopping.v1.UpdateShoppingListItemRequest.
 * Use `create(UpdateShoppingListItemRequestSchema)` to create a new message.
 */
export const UpdateShoppingListItemRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 16);

/**
 * Describes the message shopping.v1.UpdateShoppingListItemResponse.
 * Use `create(UpdateShoppingListItemResponseSchema)` to create a new message.
 */
export const UpdateShoppingListItemResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 17);

/**
 * Describes the message shopping.v1.RemoveShoppingListItemRequest.
 * Use `create(RemoveShoppingListItemRequestSchema)` to create a new message.
 */
export const RemoveShoppingListItemRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 18);

/**
 * Describes the message shopping.v1.RemoveShoppingListItemResponse.
 * Use `create(RemoveShoppingListItemResponseSchema)` to create a new message.
 */
export const RemoveShoppingListItemResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 19);

/**
 * Describes the message shopping.v1.CheckShoppingListItemRequest.
 * Use `create(CheckShoppingListItemRequestSchema)` to create a new message.
 */
export const CheckShoppingListItemRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 20);

/**
 * Describes the message shopping.v1.CheckShoppingListItemResponse.
 * Use `create(CheckShoppingListItemResponseSchema)` to create a new message.
 */
export const CheckShoppingListItemResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 21);

/**
 * Describes the message shopping.v1.PairReceiptToShoppingListRequest.
 * Use `create(PairReceiptToShoppingListRequestSchema)` to create a new message.
 */
export const PairReceiptToShoppingListRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 22);

/**
 * Describes the message shopping.v1.PairReceiptToShoppingListResponse.
 * Use `create(PairReceiptToShoppingListResponseSchema)` to create a new message.
 */
export const PairReceiptToShoppingListResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 23);

/**
 * Describes the message shopping.v1.UnpairReceiptFromShoppingListRequest.
 * Use `create(UnpairReceiptFromShoppingListRequestSchema)` to create a new message.
 */
export const UnpairReceiptFromShoppingListRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 24);

/**
 * Describes the message shopping.v1.UnpairReceiptFromShoppingListResponse.
 * Use `create(UnpairReceiptFromShoppingListResponseSchema)` to create a new message.
 */
export const UnpairReceiptFromShoppingListResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 25);

/**
 * Describes the message shopping.v1.GetShoppingListByReceiptRequest.
 * Use `create(GetShoppingListByReceiptRequestSchema)` to create a new message.
 */
export const GetShoppingListByReceiptRequestSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 26);

/**
 * Describes the message shopping.v1.GetShoppingListByReceiptResponse.
 * Use `create(GetShoppingListByReceiptResponseSchema)` to create a new message.
 */
export const GetShoppingListByReceiptResponseSchema = /*@__PURE__*/
  messageDesc(file_shopping_v1_shopping, 27);

/**
 * Describes the enum shopping.v1.ShoppingListStatus.
 */
export const ShoppingListStatusSchema = /*@__PURE__*/
  enumDesc(file_shopping_v1_shopping, 0);

/**
 * ShoppingListStatus indicates the state of a shopping list.
 *
 * @generated from enum shopping.v1.ShoppingListStatus
 */
export const ShoppingListStatus = /*@__PURE__*/
  tsEnum(ShoppingListStatusSchema);

/**
 * Describes the enum shopping.v1.ShoppingListSortField.
 */
export const ShoppingListSortFieldSchema = /*@__PURE__*/
  enumDesc(file_shopping_v1_shopping, 1);

/**
 * ShoppingListSortField specifies which field to sort by.
 *
 * @generated from enum shopping.v1.ShoppingListSortField
 */
export const ShoppingListSortField = /*@__PURE__*/
  tsEnum(ShoppingListSortFieldSchema);

/**
 * Describes the enum shopping.v1.ShoppingListSortOrder.
 */
export const ShoppingListSortOrderSchema = /*@__PURE__*/
  enumDesc(file_shopping_v1_shopping, 2);

/**
 * ShoppingListSortOrder specifies the sort direction.
 *
 * @generated from enum shopping.v1.ShoppingListSortOrder
 */
export const ShoppingListSortOrder = /*@__PURE__*/
  tsEnum(ShoppingListSortOrderSchema);

/**
 * ShoppingListService handles shopping list CRUD operations.
 *
 * @generated from service shopping.v1.ShoppingListService
 */
export const ShoppingListService = /*@__PURE__*/
  serviceDesc(file_shopping_v1_shopping, 0);

